import { RotateCcw } from 'lucide-react';
import { useId } from 'react';

import { Button } from '../../button';

import type { ReactNode } from 'react';

export function Lab({
  title,
  eyebrow,
  children,
  note,
  className = '',
}: {
  title: string;
  eyebrow: string;
  children: ReactNode;
  note?: string;
  className?: string;
}) {
  const id = useId();
  return (
    <section className={`cb-lab ${className}`} aria-labelledby={id}>
      <header>
        <span>{eyebrow}</span>
        <h3 id={id}>{title}</h3>
      </header>
      {children}
      {note ? <footer>{note}</footer> : null}
    </section>
  );
}

export function Reset({ onClick, label = 'Reset' }: { onClick: () => void; label?: string }) {
  return (
    <Button type="button" variant="ghost" size="sm" onClick={onClick}>
      <RotateCcw size={13} aria-hidden="true" />
      {label}
    </Button>
  );
}

export function Result({
  children,
  tone = 'neutral',
}: {
  children: ReactNode;
  tone?: 'neutral' | 'success' | 'warning';
}) {
  return (
    <p className="cb-result" data-tone={tone} role="status">
      {children}
    </p>
  );
}

export function Panel({
  label,
  children,
  className = '',
}: {
  label: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={`cb-panel ${className}`}>
      <h4>{label}</h4>
      {children}
    </div>
  );
}
